//正则校验
const validate = {
  /**密码校验 8-32位字母、数字、特殊字符两两组合*/
  passwordPattern() {
    return /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{12,30}$/;
    // return /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{12,30}$/;
  },
  /**手机号校验 */
  phonePattern() {
    return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    // return /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,6,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
  },
  /**邮箱校验 */
  emailPattern() {
    return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  },
  /**编码校验 (设置只能输入数字、英文、下划线、点，且必须包含英文) */
  codePattern() {
    return /^(?=.*[a-zA-Z])[\w.]+$/;
  },

  /**url路径校验 */
  urlPattern() {
    return /^(http|https|ftp):\/\/[\w\-]+(\.[\w\-]+)*([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;
  },

  /**编码校验 (设置只能输入数字、英文、下划线、点,任意组合)*/
  noWordPattern() {
    return /^[\w.]+$/;
  },
  /**编码校验 (设置只能输入数字、英文、下划线,任意组合)*/
  noPointPattern() {
    return /^[\w]+$/;
  },
  /**只能输入数字或英文 */
  wordNumPattern() {
    return /^[a-z0-9]+$/i;
  },
  /**只能输入英文、下划线 */
  otherCodePattern() {
    return /^[A-Za-z_]+$/;
  },
  /**只能输入字母 */
  wordPattern() {
    return /^[a-z]+$/i;
  },
  /**邮编校验 */
  zipCodePattern() {
    return /^[0-9]{6}$/;
  },
  /**输入框中只能输入数字 */
  numberPattern() {
    return /^\d+$/;
  },
  /**正整数 */
  isPInt(str) {
    return /^[1-9]+[0-9]*$/.test(str);
  },
  /**负整数 */
  isNInt(str) {
    return /^-[1-9]+[0-9]*$/.test(str);
  },
  /**正小数 */
  isPDec(str) {
    return /^[1-9]+[0-9]*\.[0-9]+$/.test(str) || /^0\.[0-9]+$/.test(str);
  },
  /**负小数 */
  isNDec(str) {
    return /^-[1-9]+[0-9]*\.[0-9]+$/.test(str) || /^-0\.[0-9]+$/.test(str);
  },
  /**校验只能输入数值(小数、整数、负数)，数值类型不限 */
  numberValuePattern(str) {
    return (
      str &&
      (str === "0" ||
        this.isPInt(str) ||
        this.isNInt(str) ||
        this.isPDec(str) ||
        this.isNDec(str))
    );
  },

  /**校验只能输入整数，不限正负*/
  parseIntPattern(str) {
    return str && (str === "0" || this.isPInt(str) || this.isNInt(str));
  },
  /**校验只能输入浮点数，不限正负*/
  floatPattern(floatNum) {
    return eval(`/^[-]?(0|[1-9]\\d*)\\.(\\d{${floatNum}})?$/`);
  },
  /**校验金额或百分比
   * n:最多n位整数
   * m:最多保留n位小数
   */
  numValidate(n, m) {
    if ((n > 0) & (m > 0)) {
      return eval(`/(^[1-9][0-9]{0,${n - 1}}|^[0]{1})([\.][0-9]{1,${m}})?$/`);
    } else if (n) {
      return eval(`/(^[1-9][0-9]{0,${n - 1}}|^[0]{1})([\.][0-9]{1,})?$/`);
    } else if (m) {
      return eval(`/(^[1-9][0-9]{0,}|^[0]{1})([\.][0-9]{1,${m}})?$/`);
    }
  },
  /**限制输入框只能输入正整数、0、正小数
   * @param {*} value 输入内容
   * @param {number} [intNum=15] 整数位数
   * @param {number} [decimalsNum=5] 小数位数
   */
  inputDecimal(value, intNum = 15, decimalsNum = 5) {
    let res = eval(`/([0-9]+\.[0-9]{${decimalsNum}})[0-9]*/`);
    let inputValue = value
      .replace(".", "$#$") //把第一个字符'.'替换成'$#$'
      .replace(/\./g, "") //把其余的字符'.'替换为空
      .replace("$#$", ".") //把字符'$#$'替换回原来的'.'
      .replace(/[^\d.]/g, "") //只能输入数字和'.'
      .replace(/^\./g, "") //不能以'.'开头
      .replace(/^0+/, 0)
      .replace(res, "$1"); //只保留2位小数
    //整数位保留制定位数
    inputValue =
      inputValue.indexOf(".") > 0
        ? inputValue.split(".")[0].substring(0, intNum) +
          "." +
          inputValue.split(".")[1]
        : inputValue.substring(0, intNum);
    // 校验01.1 ， 02等数据
    if (inputValue.length > 1 && inputValue[0] == 0 && inputValue[1] !== ".") {
      inputValue = inputValue.slice(1);
    }
    return inputValue;
  },

  /**限制输入框只能输入正整数*/
  inputInteger(value){
    let inputValue=value.replace(/\D/g, "");
    inputValue = inputValue && parseInt(inputValue);
    return inputValue
  },
  /**ip校验 */
  validateIp(str) {
    return /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      str
    );
  },
  /**
   * 验证是否全部为中文
   */
  validateChinese(str) {
    return !/[^\u4e00-\u9fa5]/.test(str);
  },
};
export default validate;
